import { configureStore } from '@reduxjs/toolkit'
import hubdataReducer from 'app/features/hub/hubdata'

export default configureStore({
  reducer: {
    hubdata: hubdataReducer,
  },
})
